import { companyMasterApi } from '@api/masters';
import { useRequest } from './utils';

export function useBadgeMasterAutccomplete<T>(removePublishStatus: boolean = false) {
  const { result, loading, error } = useRequest(() => companyMasterApi.badgesMaster(), []);
  if (removePublishStatus) {
    if (result) {
      result.forEach(eachBadgeMaster => delete eachBadgeMaster['publish']);
    }
    return { loading, error, master: !loading && result ? result : result };
  }
  return { loading, error, master: !loading && result ? result : result };
}
